import styled from "styled-components";

export const ConfigPageStyle = styled.div`
`;
